import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TTableHeaderCell } from './models';

export const TableHeaderCell: FC<TTableHeaderCell> = ({
    children,
    className,
    styles,
    width = '',
}) => (
    <th className={cn(styles.th, className)} style={{ width }}>
        {children}
    </th>
);
